import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Col, Row } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';

import { redirectTo } from '../../services/utils';
import { AccountRemoteSelector } from '../InsurancePolicies';
import { IconBtn } from '../Utils/Button';
import IconGG from '../Utils/Icon';
import InsuranceBrokerRemoteSelector from './InsuranceBrokerRemoteSelector';
import ExecutiveManagerRemoteSelector from './ExecutiveManagerRemoteSelector';

const AccountSection = ({ allowUpdate, setAllowUpdate, fromAdmin, modelName }) => {
  const { values } = useFormikContext();
  const history = useHistory();

  const adminUrl = fromAdmin ? '/admin' : '';
  const { accountId, insuranceBrokerId } = getIn(values, modelName);

  return (
    <>
      <section className="form-section mb-5 w-100 account-section">
        <p className="section-title">Escoge una cuenta</p>
        <Alert variant="warning" className="account-section__alert">
          <IconGG className="mr-2" icon="danger" size="sm" />
          <p className="detail font-weight-bold">Si la cuenta no existe podrás crearla en el botón “nueva cuenta”</p>
        </Alert>

        <Row className="account-section__form">
          {fromAdmin && (
            <Col md={4} lg={4}>
              <Field name={`${modelName}[insuranceBrokerId]`}>
                {({ field }) => <InsuranceBrokerRemoteSelector field={field} modelName={modelName} />}
              </Field>
            </Col>
          )}
          <Col md={4} lg={4}>
            <Field name={`${modelName}[accountId]`}>
              {({ field }) => (
                <AccountRemoteSelector
                  field={field}
                  modelName={modelName}
                  fromAdmin={fromAdmin}
                  disabled={fromAdmin && !insuranceBrokerId}
                />
              )}
            </Field>
          </Col>
          {fromAdmin && (
            <Col md={4} lg={4}>
              <Field name={`${modelName}[executiveManagerId]`}>
                {({ field }) => (
                  <ExecutiveManagerRemoteSelector
                    allowUpdate={allowUpdate}
                    setAllowUpdate={setAllowUpdate}
                    field={field}
                    modelName={modelName}
                    fromAdmin={fromAdmin}
                    disabled={fromAdmin && !accountId}
                  />
                )}
              </Field>
            </Col>
          )}
          <Col className="account-section__form__btn">
            <IconBtn
              icon="add"
              className="mt-lg-0"
              onClick={() => redirectTo(history, `${adminUrl}/accounts/new`, { insuranceBrokerId })}
            >
              Nueva cuenta
            </IconBtn>
          </Col>
        </Row>
      </section>

      <hr className="w-100 mb-5" />
    </>
  );
};

export default AccountSection;
